import { Box, Flex, Group, Stack, Title } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AllCentersReportButton } from '@/module/ResearchCenter/components/AllCentersReportButton';

import { AddButtonLink, NoContentPlaceholder } from '@/core/components';

import { useCurrentUser } from '@feature/security';

import { ResearchCenterCard } from './components/Card/ResearchCenterCard';
import { getResearchCentersOptions } from './model/ResearchCenterQuery';

export function ResearchCenterBrowse() {
  const { t } = useTranslation();
  const { data } = useSuspenseQuery(getResearchCentersOptions());
  const { currentRole } = useCurrentUser();

  return (
    <Stack>
      <Flex justify="space-between">
        <Group>
          <Title>{t('researchCenters.title')}</Title>
          {currentRole === 'UNIVERSITY_ADMIN' && <AllCentersReportButton />}
        </Group>
        <AddButtonLink />
      </Flex>
      {data != null && data.length > 0 ? (
        <Box>
          <Stack>
            {data.map(item => (
              <ResearchCenterCard
                key={item.id}
                researchCenter={item}
                to={`${item.id}`}
              />
            ))}
          </Stack>
        </Box>
      ) : (
        <NoContentPlaceholder title={t('noContent.title')} />
      )}
    </Stack>
  );
}
